import httpClient from '../core/httpClient';
import secrets from '../core/secrets';
import { clearAuthSession, getRefreshToken, saveAuthSession } from './authStorage';
import { extractAuthTokenPayload } from './authTokenResponse';
import { syncAppSettingsFromServer } from '../users/appSettingsStorage';
import { clearCachedVoyagesList } from '../shipJournal/voyagesApi';
import { clearCachedUserProfile } from '../users/usersApi';

function validateOAuthSecrets() {
  if (!secrets.clientId || !secrets.clientSecret) {
    throw new Error('Brak client_id lub client_secret w src/api/secrets.js');
  }
}

export async function loginWithPassword({ email, password, remember = true }) {
  validateOAuthSecrets();

  const response = await httpClient.post('/api/v2/login', {
    email,
    password,
    client_id: secrets.clientId,
    client_secret: secrets.clientSecret,
  });

  const envelope = response.data;
  const tokenPayload = extractAuthTokenPayload(
    envelope,
    response,
    'Logowanie nie powiodło się',
  );

  const sessionLabel = tokenPayload.username ?? tokenPayload.email ?? email;
  const sessionEmail = tokenPayload.email ?? email;
  saveAuthSession(tokenPayload, sessionLabel, sessionEmail, { remember });
  clearCachedUserProfile();
  clearCachedVoyagesList();
  syncAppSettingsFromServer().catch((error) => {
    console.warn('[authApi] loginWithPassword: nie udało się zsynchronizować ustawień', error);
  });
  console.info('[authApi] loginWithPassword: zalogowano', { username: sessionLabel });
  return envelope;
}

export async function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    clearAuthSession();
    throw new Error('Brak refresh tokenu');
  }

  validateOAuthSecrets();

  const response = await httpClient.post('/api/v2/refresh-token', {
    refresh_token: refreshToken,
    client_id: secrets.clientId,
    client_secret: secrets.clientSecret,
  });

  const envelope = response.data;
  const tokenPayload = extractAuthTokenPayload(
    envelope,
    response,
    'Odświeżanie tokenu nie powiodło się',
  );

  saveAuthSession(tokenPayload);
  console.info('[authApi] refreshAccessToken: token odświeżony');
  return envelope;
}

export async function registerUser({
  username,
  email,
  password,
  phone_number,
  country,
  birth_date,
}) {
  const payload = {
    username,
    email,
    password,
    ...(phone_number ? { phone_number } : {}),
    ...(country ? { country } : {}),
    ...(birth_date ? { birth_date } : {}),
  };

  const response = await httpClient.post('/api/v2/register', payload);
  const body = response.data;
  console.info('[authApi] registerUser:', body?.message);
  return body;
}

export async function logoutUser() {
  const response = await httpClient.post('/api/v2/logout');
  const body = response.data;
  console.info('[authApi] logoutUser:', body?.message);
  return body;
}

export async function forgotPassword({ email }) {
  const response = await httpClient.post('/api/v2/forgot-password', { email });
  const body = response.data;
  console.info('[authApi] forgotPassword:', body?.message);
  return body;
}

export async function resetPassword({ token, new_password }) {
  const response = await httpClient.post(
    `/api/v2/reset-password/${token}`,
    { new_password },
  );
  const body = response.data;
  console.info('[authApi] resetPassword:', body?.message);
  return body;
}

export async function confirmAccount({ token }) {
  const response = await httpClient.get(`/api/v2/confirm-account/${token}`);
  const body = response.data;
  console.info('[authApi] confirmAccount:', body?.message);
  return body;
}
